import { Button } from 'features/common/components/Button';
import { Icon as UnstyledIcon } from 'features/common/components/Icon';
import { Text as UnstyledText } from 'features/common/components/Text';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	width: 100%;
	padding: 45px 80px 20px;
	box-sizing: border-box;
	position: relative;
	color: ${({ theme }) => theme.colors.black};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;
		padding: 0 0 24px;
		height: auto;
	}
`;

export const InnerContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}
`;

export const InfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	cursor: default;
	max-width: 100%;
	gap: 10px;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
		max-width: 100%;
		gap: 6px;
	}
`;

export const ActionButtonsContainer = styled.div`
	display: flex;
	align-self: flex-start;
	gap: 5px;
	right: 10px;
	top: 10px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		margin-top: 18px;
		justify-content: center;
		gap: 0;
	}
`;

export const MobileMenuButton = styled.button`
	position: absolute;
	right: 0;
	top: 0;
	background: none;
	border: none;
	cursor: pointer;
	display: none;
	align-items: center;
	justify-content: center;
	padding: 8px;
	border-radius: 6px;
	color: ${({ theme }) => theme.colors.black};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		display: flex;
	}
`;

export const MobileDropdownContainer = styled.div`
	position: absolute;
	right: 10px;
	top: 10px;
	display: none;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		display: block;
	}
`;

export const BoxOfficeDropdownContainer = styled.div`
	position: relative;
`;

export const MobileDropdownMenu = styled.div`
	position: absolute;
	top: calc(100% + 4px);
	right: 0;
	background-color: var(--punchup-color-bg);
	border-radius: var(--punchup-radius-md);
	box-shadow: var(--punchup-shadow-md);
	min-width: 220px;
	z-index: 9999;
	overflow: hidden;
	border: 1px solid var(--punchup-color-border);
	padding: var(--punchup-space-2) 0;
`;

export const DropdownSeparator = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.colors.lightGrey};
	opacity: 0.3;
	margin: 0 8px;
`;

export const ActionButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
	background: none;
	border: none;
	cursor: pointer;
	font-size: 20px;
	height: 40px;
	width: 40px;
	color: ${({ theme }) => theme.colors.lightGrey};
	border-radius: 6px;
	padding: 4px 8px;
	background-color: ${({ theme }) => theme.colors.white};
	position: relative;
	transition: all 0.2s ease;

	&:hover {
		border-color: ${({ theme }) => theme.colors.punchupOrange};
		color: ${({ theme }) => theme.colors.punchupOrange};
		transform: scale(1.05);
	}

	&::after {
		content: attr(title);
		position: absolute;
		bottom: -35px;
		left: 50%;
		transform: translateX(-50%);
		background-color: rgba(0, 0, 0, 0.85);
		color: white;
		padding: 6px 12px;
		border-radius: 6px;
		font-size: 12px;
		white-space: nowrap;
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.2s ease;
		z-index: 1000;
	}

	&:hover::after {
		opacity: 1;
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		&::after {
			display: none;
		}
	}
`;

export const MobileActionButton = styled.button<{ bottomBorder?: boolean; isDelete?: boolean }>`
	display: flex;
	align-items: center;
	gap: var(--punchup-space-3);
	padding: var(--punchup-space-3) var(--punchup-space-4);
	background: none;
	border: none;
	cursor: pointer;
	font-size: var(--punchup-font-size-sm);
	line-height: 20px;
	color: ${({ isDelete }) => (isDelete ? 'var(--punchup-color-destructive)' : 'var(--punchup-color-text)')};
	width: 100%;
	justify-content: flex-start;
	text-align: left;
	transition: background 0.12s ease;

	&:hover:not(:disabled) {
		background: ${({ isDelete }) => (isDelete ? 'var(--punchup-color-danger-bg)' : 'var(--punchup-color-surface)')};
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

export const Icon = styled(UnstyledIcon)`
	cursor: pointer;
	filter: brightness(0);
`;

export const SocialMediaLink = styled.a`
	display: inline-block;
	text-decoration: none;
	background-size: contain;
	background-repeat: no-repeat;
	width: 45px;
	height: 45px;
`;

export const SocialNetworkContainer = styled.div`
	margin-top: 14px;
`;

export const Title = styled(UnstyledText)`
	font-weight: 700;
	font-size: 32px;
	line-height: 40px;

	> img {
		margin-left: 20px;
	}

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		font-weight: 600;
		font-size: 18px;
		line-height: 46px;
	}
`;

export const Text = styled(UnstyledText)`
	font-weight: 400;
	font-size: 14px;
	line-height: 24px;
	max-width: calc(100% - 24px);
	white-space: nowrap;
`;

export const Image = styled.img`
	width: 186px;
	height: 173px;
	top: 74px;
	object-fit: cover;
	border-radius: 8px;
	gap: 10px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 60px;
		height: 60px;
		border-radius: 4px;
	}
`;

export const OutlinedButtonContainer = styled.div`
	display: flex;
	gap: 10px;
`;

export const OutlinedButton = styled(Button)`
	border-radius: 8px;
	display: flex;
	justify-content: center;
	font-size: small;
	align-items: center;
	width: fit-content;
	padding: 2px 10px;
	margin: 0px;
`;

export const OutlinedLinkButton = styled.a`
	background: transparent;
	border: ${({ theme }) => `1px solid ${theme.colors.green}`};
	color: ${({ theme }) => theme.colors.green};
	cursor: pointer;
	font-size: small;
	border-radius: 8px;
	width: fit-content;
	padding: 2px 10px;
	text-decoration: none;
	text-align: center;
`;
